import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function ratingsModuleSelector(state: IInitialState) {
	return moduleStateSelector(state).ratingsModule;
}
